<template>
  <div class="summary">
    <div class="all-summary-grid">
      <store-summary class="store-sum"/>
      <driver-summary class="driver-sum"/>
    </div>
  </div>
</template>

<script>
import StoreSummary from '../views/StoreSummary.vue'
import DriverSummary from '../views/DriverSummary.vue'
export default { name: 'Summary', components: { StoreSummary, DriverSummary } }
</script>

<style scoped>
.summary {
  margin-bottom: 50px;
  padding: 25px;
}
.title-text-style {
  text-align: left;
  margin-top: 10px;
  margin-left: 0px;
  margin-bottom: 10px;
  font-size: 30px;
  color: #1e4b84;
}
.all-summary-grid {
  display: grid;
  grid-template-columns: 100%;
  grid-template-areas:
    'store-sum'
    'driver-sum';
  column-gap: 20px;
  row-gap: 20px;
}
.store-sum {
  /* display: none; */
  grid-area: store-sum;
  min-height: 550px;
}
.driver-sum {
  grid-area: driver-sum;
  min-height: 500px;
}
</style>
